import React from "react";
import styled, { css } from "styled-components";
import { Container } from '../../globalStyles';

export const ContactSection = styled.div`
  padding: 50px 0 80px;
  display: inline-block;
    margin: auto 150px;
   
`;

export const ContactgHeading = styled.h1`
  color: #eb594c;
  font-size: 48px;
  margin-bottom: 24px;
  text-align: center;

  @media screen and (max-width: 960px) {
   
    justify-content: center;
    align-items: center;
    width: 300px;
    height:100%;
    margin: 0 0  0 -120px
  }

`;

export const ContactContainer = styled.div`
  width:1000px;
  align-items: center;
  margin:0 80px;
  display:grid;  
  grid-template-rows:repeat(1,150px);
  grid-template-columns:repeat(2,1.5fr);
  grid-gap:40px;

  @media screen and (max-width: 960px) {
    display:grid;  
  grid-template-rows:repeat(1,150px);
  grid-template-columns:repeat(1,4fr);
    justify-content: center;
    align-items: center;
    width: 300px;
    height:100%;
    margin: 0 0  0 -120px
      }
`;
export const ContactWrapper = styled.div`
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 0px 40px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  display:flex;
  align-items: center;
  height:100px;
  @media screen and (max-width: 960px) {
    margin: 20px 30px 0 170px;
    display: flex;
    width:300px;
    flex-direction: column;
    align-items: center;
  }
`;
export const SocialIconLink = styled.a`
  color: #eb594c ;
  font-size: 30px;
  margin: 0  -100px  0 100px;

    @media screen and (max-width: 960px) {
    text-align: center;
    margin: 15px 30px 0 30px
  }
   &:hover {
      color: #c9d66a
      }
`;
export const ContactText = styled.p`
  display: block;
  width: 100%;
  font-size: 22px;
  text-align: center;
color: #909284;
padding:10px;
    @media screen and (max-width: 960px) {
    align-items: center;
          font-size: 18px;
 &:hover {
      color: #c9d66a
      }

  }
`;
export const SocialContainer = styled.div`
  width:1000px;
  align-items: center;
  display:grid;  
  grid-template-rows:repeat(1,30px);
  grid-template-columns:repeat(5,0.5fr);
  grid-gap:40px;
  /* margin: 0 0  0 80px; */

  @media screen and (max-width: 960px) {
    display:grid;  
  grid-template-rows:repeat(5,30px);
  grid-template-columns:repeat(1,1fr);
    justify-content: center;
    align-items: center;
    width: 300px;
    height:150;
    margin: 30px -50px 0 -50px;
      
      }
`;
export const SocialLink = styled.a`
  color: #eb594c ;
  font-size:25px;
    text-align: center;
 box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 0px 40px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  padding:8px;
      @media screen and (max-width: 960px) {
    align-items: center;
          font-size: 18px;
      }
      &:hover {
      color: #c9d66a
      }
`;

export const EmailContainer = styled.div`
  width:1000px;
  align-items: center;
  display:grid;  
  grid-template-rows:repeat(1,150px);
  grid-template-columns:repeat(3,1fr);
  grid-gap:40px;
  margin: 30px 50px  0 80px;

  @media screen and (max-width: 960px) {
    display:grid;  
  grid-template-rows:repeat(3,100px);
  grid-template-columns:repeat(1,1fr);
    justify-content: center;
    align-items: center;
    width: 300px;
    height:150;
    margin: 30px 0  0 -50px
      }
`;

export const EmaiWrapper = styled.p`
  color: #909284 ;
  font-size:25px;
    text-align: center;
 box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 0px 40px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  padding:8px;
      @media screen and (max-width: 960px) {
    align-items: center;
    margin-top:70px;
          font-size: 16px;
      }
`;
export const EmailIcon = styled.a`
  color: #eb594c ;
  font-size:25px;
    text-align: center;
  border-radius: 5px;
  padding:8px;
      @media screen and (max-width: 960px) {
    align-items: center;
          font-size: 18px;
            margin: 120px;
      }
       &:hover {
      color: #c9d66a
      }
`;


export const AddressContainer = styled.div`
  width:1000px;
  align-items: center;
  margin:0 80px;
  display:grid;  
  grid-template-rows:repeat(1,150px);
  grid-template-columns:repeat(2,1.5fr);
  grid-gap:40px;

  @media screen and (max-width: 960px) {
    display:grid;  
  grid-template-rows:repeat(1,150px);
  grid-template-columns:repeat(1,4fr);
    justify-content: center;
    align-items: center;
    width: 300px;
    height:100%;
    margin: 40px 0  0 -120px
      }
`;

export const AddressWrapper = styled.a`
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 0px 40px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  display:flex;
  align-items: center;
  height:100px;
  @media screen and (max-width: 960px) {
    margin: 20px 30px 0 170px;
    display: flex;
    width:300px;
    flex-direction: column;
    align-items: center;
  }
`;











export const CardWrapper = styled.form`
  overflow: hidden;
  padding: 0 0 32px;
  margin: 48px auto 0;
  font-family: Quicksand, arial, sans-serif;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 0px 40px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  display:block;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width:1000px;

  @media screen and (max-width: 960px) {
    margin: 20px -48px;
    display: flex;
    flex-direction: column;
    align-items: center;
      width: 300px;

  }
`; 

export const CardBody = styled.div`
  padding-right: 32px;
  padding-left: 32px;
  padding-top: 32px;
  width:1000px;

  @media screen and (max-width:960px){
  width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const CardFieldset = styled.fieldset`
  position: relative;
  padding: 0;
  margin: 0;
  border: 0;

  & + & {
    margin-top: 24px;
  }

  &:nth-last-of-type(2) {
    margin-top: 32px;
  }

  &:last-of-type {
    text-align: center;
  }
`;

export const CardInput = styled.input`
  padding: 7px 0;
  width: 100%;
  font-family: inherit;
  font-size: 14px;
  border-top: 0;
  border-right: 0;
  border-bottom: 1px solid #ddd;
  border-left: 0;
  transition: border-bottom-color 0.25s ease-in;

  &:focus {
    border-bottom-color: #e5195f;
    outline: 0;
  }
`;

